export default "__VITE_ASSET__BwqkqJhh__"